import { Injectable } from '@angular/core';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { PotentialParticipantList } from '@app/shared/models/participant';

@Injectable({
    providedIn: 'root'
})
export class PotentialParticipantService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(httpServiceBundle);
    }

    public query(type?: string): Observable<PotentialParticipantList[]> {
        const uri = `${this.uri}/${BackendUriUnits.POTENTIAL_PARTICIPANTS}`;
        return this.http.get(uri, type ? { params: { test: type} } : {})
                        .pipe(map((result: any) => {
                            return result.data.map(entry => new PotentialParticipantList(entry.key, entry.value));
                        }));
    }
}
